import { ConditionGroup, conditionGroupChildenKey, DesignState } from 'editor/src/store/design/types';

import getConditionChildrenKey from './getConditionChildrenKey';

/**
 * Moves an option's linked elements back to the top-level bucket (unless
 * locked) and drops the option's children bucket entirely.
 *
 * Shared by removeConditionOptionReducer (removing a single option, guarded to
 * keep at least 2 left) and importConditionReducer (replacing the whole option
 * set at once, so every old option goes through this with no such guard).
 *
 * Condition-type children (sub-conditions parented to this option) are left
 * untouched here — matching the pre-existing behaviour this was extracted
 * from: `child.id` is a condition id for those, which never matches a media
 * `uuid`, so they are silently NOT moved to the top bucket. They stay in
 * `conditions` with a `parent` that no longer resolves to a live bucket —
 * unreachable from the tree, but not deleted. Not fixed here: this helper only
 * reproduces existing behaviour for a second caller, it does not change it.
 */
function releaseConditionOptionChildren(
  state: DesignState,
  conditionGroup: ConditionGroup,
  spreadIndex: number,
  conditionId: string,
  optionId: string,
) {
  const childrenKey = getConditionChildrenKey(conditionId, optionId);
  const removedChildren = conditionGroup.children[childrenKey];
  removedChildren?.forEach((child) => {
    const element = state.designData?.spreads[spreadIndex].pages[0].groups.media?.find(
      (element) => element.uuid === child.id,
    );
    if (element && !element.personalizationLocked) {
      conditionGroup.children[conditionGroupChildenKey].push(child);
    }
  });
  delete conditionGroup.children[childrenKey];
}

export default releaseConditionOptionChildren;
